/**
 * Facebook Pixel Event Tracking
 * Pixel ID: 3221054491463961
 */

// Check if fbq is available
const fbq = (...args) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(...args);
  }
};

/**
 * Track page view - automatically called by pixel base code
 */
export const trackPageView = () => {
  fbq('track', 'PageView');
};

/**
 * Track when user views key content (sales page, pricing, etc.)
 */
export const trackViewContent = (contentName, contentCategory = 'page') => {
  fbq('track', 'ViewContent', {
    content_name: contentName,
    content_category: contentCategory,
  });
};

/**
 * Track when a guest creates a character (shows strong intent)
 */
export const trackLead = (characterName = '') => {
  fbq('track', 'Lead', {
    content_name: 'Guest Character Created',
    content_category: 'character',
    value: characterName,
  });
};

/**
 * Track when user starts the story creation process
 */
export const trackInitiateCheckout = (storyTitle = '') => {
  fbq('track', 'InitiateCheckout', {
    content_name: 'Story Creation Started',
    content_category: 'story',
    value: storyTitle,
  });
};

/**
 * Track when a user completes registration - MAIN CONVERSION EVENT
 */
export const trackCompleteRegistration = (method = 'email') => {
  fbq('track', 'CompleteRegistration', {
    content_name: 'User Signup',
    status: 'complete',
    method: method,
  });
};

/**
 * Track when user starts a free trial / creates first story
 */
export const trackStartTrial = (storyTitle = '') => {
  fbq('track', 'StartTrial', {
    content_name: storyTitle || 'First Story',
    content_category: 'story',
  });
};

/**
 * Track when user subscribes to a paid plan
 */
export const trackSubscribe = (planName, value, currency = 'USD') => {
  fbq('track', 'Subscribe', {
    content_name: planName,
    value: value,
    currency: currency,
  });
};

/**
 * Track purchase (for one-time purchases or upgrades)
 */
export const trackPurchase = (value, currency = 'USD', contentName = '') => {
  fbq('track', 'Purchase', {
    content_name: contentName,
    value: value,
    currency: currency,
  });
};

/**
 * Track custom events
 */
export const trackCustomEvent = (eventName, params = {}) => {
  fbq('trackCustom', eventName, params);
};

export default {
  trackPageView,
  trackViewContent,
  trackLead,
  trackInitiateCheckout,
  trackCompleteRegistration,
  trackStartTrial,
  trackSubscribe,
  trackPurchase,
  trackCustomEvent,
};
